<template>
  <div :class="['crankset-filters-length', 'crankset-filters-length--active']">
    <BfFlex
      align="center"
      gap="1.6rem"
    >
      <BfInput
        v-model="filterLength"
        class="crankset-filters-length__input"
        type="number"
        :unit="t('common.unit.mm')"
        :min="minLength"
        :max="maxLength"
        :step="2.5"
        @focus="setLastLength"
        @blur="checkLength"
      />
      <n-slider
        v-model:value="filterLength"
        class="crankset-filters-length__slider"
        :min="minLength"
        :max="maxLength"
        :step="2.5"
      />
      <div class="crankset-filters-length__buttons">
        <BfButton
          :color="Colors.Light"
          class="crankset-filters-length__button"
          @click="cancel"
          >{{ t('common.cancel') }}</BfButton
        >
        <BfButton
          :color="Colors.Light"
          class="crankset-filters-length__button"
          @click="save"
          >{{ t('common.save') }}</BfButton
        >
      </div>
    </BfFlex>
  </div>
</template>

<script setup lang="ts">
import { ref } from 'vue'
import { storeToRefs } from 'pinia'
import { useCranksetStore } from '@/store/cranksetStore'
import { useMeasurementStore } from '@/store/measurementStore'
import { BfFlex, BfInput, BfButton, Colors } from '@finetic/bikefitting-ui'
import { useI18n } from 'vue-i18n'
import { NSlider } from 'naive-ui'

const { t } = useI18n()
const lastLength = ref(0)
const minLength = ref(140)
const maxLength = ref(175)

const emit = defineEmits(['save', 'cancel'])

const cranksetStore = useCranksetStore()
const measurementStore = useMeasurementStore()
const { filterLength } = storeToRefs(cranksetStore)

const setLastLength = () => {
  lastLength.value = filterLength.value
}

const checkLength = () => {
  if (
    filterLength.value < minLength.value ||
    filterLength.value > maxLength.value
  ) {
    filterLength.value = lastLength.value
  }
}

const save = () => {
  if (measurementStore.selectedMeasurement) {
    measurementStore.selectedMeasurement.crankset.active = filterLength.value
  }

  emit('save')
}

const cancel = () => {
  emit('cancel')
}
</script>

<style lang="scss">
.crankset-filters-length {
  background-color: var(--color-dark-10);
  border: solid 0.1rem var(--color-dark-20);
  border-radius: 0.4rem;
  padding: 1.2rem;
  margin-top: 2.4rem;

  &--active {
    background: linear-gradient(var(--color-primary), var(--color-secondary));
    border-color: var(--color-secondary);
  }

  &__buttons {
    display: flex;
    gap: 8px;
  }

  &__input {
    flex: 1 0 20%;
  }

  &__slider {
    flex: 1 0 40%;
  }
}
</style>
